import React, { useContext, useEffect, useState } from "react"
import DisLoansComp from "../Loan/DisbursedLoans"
import AcceptedLoans from "../Loan/AcctAcceptedLoans"
import TabHeader from "../TabHeader"
import { AuthContext } from "context/AuthContext"
import { useSearchParams } from "react-router-dom"
import ApprovedLoans from "../Loan/ApprovedLoans";
// import { withContext } from "context/AccountantContext"


const tabs = [
	{ label: "Approved", index: 1 },
	{ label: "Disbursed", index: 2 },
]

export default function AccountantTabs() {
	const { adminProfile } = useContext(AuthContext)
	const adminRole = adminProfile.admin_role
	const [toggleState, setToggleState] = useState(1)

	const [params, setParams] = useSearchParams()

	const handleSetTab = (tab) => {
		setParams({ tab })
		setToggleState(tab)
	}

	useEffect(() => {
		const currentTab = params.get("tab")
		if (currentTab) {
			setToggleState(parseInt(currentTab))
		}
	}, [params])

	return (
		<section className="bg-gray-100">
			<TabHeader
				currentTab={toggleState}
				selectTab={handleSetTab}
				tabs={tabs}
			/>
			<div className="p-6">
				{toggleState === 1
					? (
						<div className={toggleState === 1 ? "content  active-content" : "content"}>
							<h1 className="text-4xl my-8 mb-12 font-semibold text-[#333333]">Approved Loans</h1>
							<ApprovedLoans />
							{/* <LoanTable allLoans={loans} /> */}
						</div>
					)
					: (
						<div className={toggleState === 2 ? "content  active-content" : "content"}>
							<h1 className="text-4xl my-8 mb-12 font-semibold text-[#333333]">Disbursed Loans</h1>
							<DisLoansComp />
							{/* <LoanTable allLoans={loans} /> */}
						</div>
					)}
			</div>
		</section>
	)
}
